import {
  isMobile
} from "./chunk.XRUCOIZT.js";
import {
  date_picker_styles_default
} from "./chunk.3F3EA6TX.js";
import {
  formatForDateInput
} from "./chunk.HLRT5FOM.js";
import {
  DateTime
} from "./chunk.JAWPSPJ3.js";
import {
  FormControl
} from "./chunk.HH2JJZ37.js";
import {
  createPopper
} from "./chunk.A364I6JA.js";
import {
  animateTo,
  stopAnimations
} from "./chunk.JEYCYKK2.js";
import {
  dateAttributeConverter
} from "./chunk.MIOPVZYG.js";
import {
  l
} from "./chunk.SUTDMD3F.js";
import {
  emit
} from "./chunk.C4ZTYQN4.js";
import {
  watch
} from "./chunk.WGQU6RP3.js";
import {
  getAnimation,
  setDefaultAnimation
} from "./chunk.456HIP2G.js";
import {
  e,
  i,
  t
} from "./chunk.D5EJUUKV.js";
import {
  $,
  w
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/date-picker/base-picker.ts
import { t as t2 } from "i18next";
var FadvBaseDatePicker = class extends FormControl {
  constructor() {
    super(...arguments);
    this.required = false;
    this.clearable = false;
    this.open = false;
  }
  connectedCallback() {
    super.connectedCallback();
    this.handleDocumentMousedown = this.handleDocumentMousedown.bind(this);
    this.handleDocumentKeydown = this.handleDocumentKeydown.bind(this);
    document.addEventListener("mousedown", this.handleDocumentMousedown);
    document.addEventListener("keydown", this.handleDocumentKeydown);
  }
  disconnectedCallback() {
    document.removeEventListener("mousedown", this.handleDocumentMousedown);
    document.removeEventListener("keydown", this.handleDocumentKeydown);
    this.destroyCalendarPopover();
    super.disconnectedCallback();
  }
  handleIconClick(e2) {
    if (isMobile() && !this.datePattern) {
      this.focus();
    } else {
      this.open = !this.open;
      e2.preventDefault();
      e2.stopPropagation();
    }
  }
  handleDocumentMousedown(e2) {
    if (!e2.composedPath().includes(this)) {
      this.open = false;
    }
  }
  handleDocumentKeydown(e2) {
    if (e2.key === "Escape") {
      this.open = false;
    }
  }
  handleInputClick(e2) {
    if (!isMobile()) {
      e2.preventDefault();
      e2.stopImmediatePropagation();
      return;
    }
    e2.stopPropagation();
  }
  async handleOpenChange() {
    var _a;
    if (this.disabled) {
      return;
    }
    if (this.open) {
      emit(this, "sl-show");
      await stopAnimations(this);
      this.createCalendarPopover();
      (_a = this.popoverInstance) == null ? void 0 : _a.update();
      this.calendar.hidden = false;
      const { keyframes, options } = getAnimation(this, "date-picker.show");
      await animateTo(this.calendar, keyframes, options);
      this.calendar.focus();
      emit(this, "sl-after-show");
    } else {
      emit(this, "sl-hide");
      await stopAnimations(this);
      const { keyframes, options } = getAnimation(this, "date-picker.hide");
      await animateTo(this.calendar, keyframes, options);
      this.calendar.hidden = true;
      this.destroyCalendarPopover();
      this.calendarTrigger.focus();
      emit(this, "sl-after-hide");
    }
  }
  handleClearClick(event) {
    this.clear();
    event.stopPropagation();
  }
  handleInputKeydown(e2) {
    if (!isMobile()) {
      if (e2.key === "Delete") {
        this.clear();
      }
      if (e2.key === "Enter") {
        e2.preventDefault();
      }
      if (e2.altKey && e2.key === "ArrowDown" || e2.key === " ") {
        this.open = true;
        this.blur();
        e2.preventDefault();
      }
    }
  }
  createCalendarPopover() {
    this.popoverInstance = createPopper(this.host, this.positioner, {
      placement: "bottom-start",
      strategy: "fixed",
      modifiers: [
        {
          name: "flip",
          options: {
            boundary: "viewport"
          }
        },
        {
          name: "offset",
          options: {
            offset: [0, 2]
          }
        }
      ]
    });
  }
  destroyCalendarPopover() {
    var _a;
    (_a = this.popoverInstance) == null ? void 0 : _a.destroy();
  }
  isInRange(date) {
    const inMinRange = !this.min || this.min && date >= this.min;
    const inMaxRange = !this.max || this.max && date <= this.max;
    return inMinRange && inMaxRange;
  }
  getIconColor() {
    if (this.variant === "monochrome")
      return void 0;
    return this.open ? this.variant : "neutral";
  }
  getDateInputValue(date) {
    if (!date)
      return "";
    if (this.datePattern)
      return this.getPatternFormattedDate(date);
    return formatForDateInput(date) || "";
  }
  getPatternFormattedDate(date) {
    if (!date)
      return "";
    if (!this.datePattern)
      return "";
    return DateTime.fromJSDate(date).toFormat(this.datePattern);
  }
  handleInputFocus(event) {
    super.handleFocus();
    if (isMobile() && !this.datePattern) {
      try {
        if (event.target && "showPicker" in event.target) {
          event.target.showPicker();
        }
      } catch (e2) {
      }
    }
  }
  renderBelow() {
    return $`<div class="date-picker__positioner">${this.renderCalendar()}</div>`;
  }
  renderClearable() {
    if (!this.clearable)
      return w;
    if (!this.hasValue)
      return w;
    return $`<button aria-label=${t2("components:common.clearEntry")} part="clear-button" class="input__clear" type="button" @click=${this.handleClearClick} tabindex="-1" ><slot name="clear-icon"><fadv-icon name="circle-xmark" library="solid"></fadv-icon></slot></button>`;
  }
  renderControl() {
    return $`<span part="prefix" class="form-control__control--prefix"><slot name="prefix"></slot></span><div class="form-control__control-host" @click=${this.focus}>${this.renderFloatingLabel()}${this.renderInput()}</div>${this.renderClearable()}<span part="suffix" class="form-control__control--suffix"><button ?disabled=${this.disabled} slot="suffix" class="date-picker__calendar-icon" @click=${this.handleIconClick}><fadv-icon library="solid" name="fa-calendar-days" size="small" foreground="${l(this.getIconColor())}"></fadv-icon></button></span>`;
  }
};
FadvBaseDatePicker.styles = [...FormControl.styles, date_picker_styles_default];
__decorateClass([
  e({ type: Boolean, reflect: true })
], FadvBaseDatePicker.prototype, "required", 2);
__decorateClass([
  e({ type: Boolean })
], FadvBaseDatePicker.prototype, "clearable", 2);
__decorateClass([
  e({ type: Boolean })
], FadvBaseDatePicker.prototype, "autofocus", 2);
__decorateClass([
  e({ reflect: true, converter: dateAttributeConverter, attribute: "min" })
], FadvBaseDatePicker.prototype, "min", 2);
__decorateClass([
  e({ reflect: true, converter: dateAttributeConverter, attribute: "max" })
], FadvBaseDatePicker.prototype, "max", 2);
__decorateClass([
  e({ attribute: "date-pattern" })
], FadvBaseDatePicker.prototype, "datePattern", 2);
__decorateClass([
  i("fadv-calendar")
], FadvBaseDatePicker.prototype, "calendar", 2);
__decorateClass([
  i(".form-control__control-host")
], FadvBaseDatePicker.prototype, "host", 2);
__decorateClass([
  i(".date-picker__positioner")
], FadvBaseDatePicker.prototype, "positioner", 2);
__decorateClass([
  i(".date-picker__calendar-icon")
], FadvBaseDatePicker.prototype, "calendarTrigger", 2);
__decorateClass([
  t()
], FadvBaseDatePicker.prototype, "open", 2);
__decorateClass([
  watch("open", { waitUntilFirstUpdate: true })
], FadvBaseDatePicker.prototype, "handleOpenChange", 1);
setDefaultAnimation("date-picker.show", {
  keyframes: [
    { opacity: 0, transform: "scale(0.9)" },
    { opacity: 1, transform: "scale(1)" }
  ],
  options: { duration: 150, easing: "ease" }
});
setDefaultAnimation("date-picker.hide", {
  keyframes: [
    { opacity: 1, transform: "scale(1)" },
    { opacity: 0, transform: "scale(0.9)" }
  ],
  options: { duration: 150, easing: "ease" }
});

export {
  FadvBaseDatePicker
};
